import { AlertCircle, CheckCircle2 } from "lucide-react";

interface ValidationMessageProps {
  message: string | null;
  isValid?: boolean;
}

const ValidationMessage = ({ message, isValid }: ValidationMessageProps) => {
  if (!message && !isValid) return null;

  if (isValid) {
    return (
      <p className="flex items-center gap-1.5 text-xs text-emerald-600 mt-1">
        <CheckCircle2 className="h-3.5 w-3.5" />
        Válido
      </p>
    );
  }

  return (
    <p className="flex items-center gap-1.5 text-xs text-destructive mt-1">
      <AlertCircle className="h-3.5 w-3.5" />
      {message}
    </p>
  );
};

export default ValidationMessage;
